/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Ares_LoadedInputs */

const cs_auth_signup_ares_loaded = /** @type {(inputs: Auth_Signup_Ares_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Údaje načteny z ARES`)
};

const en_auth_signup_ares_loaded = /** @type {(inputs: Auth_Signup_Ares_LoadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company details loaded from ARES`)
};

/**
* | output |
* | --- |
* | "Company details loaded from ARES" |
*
* @param {Auth_Signup_Ares_LoadedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_ares_loaded = /** @type {((inputs?: Auth_Signup_Ares_LoadedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Ares_LoadedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_ares_loaded(inputs)
	return cs_auth_signup_ares_loaded(inputs)
});